import { Component } from '@angular/core';
import {AuthService} from "../../../core/services/auth/auth.service";
import {Response} from "../../../models/Response";
import {User} from "../../../models/User";
import {FormsModule} from "@angular/forms";
import {AuthStateService} from "../../../core/services/auth/auth-state.service";
import {Router, RouterLink} from "@angular/router";
import {NgxSpinnerService} from "ngx-spinner";
import {AuthFormInputDirective} from "../../../shared/directives/auth/auth-form-input.directive";
import {AuthFormLabelDirective} from "../../../shared/directives/auth/auth-form-label.directive";
import {ToastrService} from "ngx-toastr";
@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    FormsModule,
    RouterLink,
    AuthFormInputDirective,
    AuthFormLabelDirective,
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css'
})
export class LoginComponent {
  loading: boolean = false;

  email: string = "";
  password: string = "";

  constructor(private authService: AuthService, private authStateService: AuthStateService, private router: Router,
              private spinner: NgxSpinnerService,private toast: ToastrService) {
    // console.log(this.authStateService.isLoggedIn());
  }

  loginClick() {
    this.loadingFunc(true);
    this.authService.signIn({
      email: this.email,
      password: this.password
    }).subscribe({
      next: (data: Response<User>) => {
        if (data.data) {
          this.authStateService.setUser(data.data);
          this.router.navigate(['/dashboard'])
        } else {
          this.authStateService.setUser(null);
        }
      },
      error: (error) => {
        this.toast.error(error.error?.message || 'Error al iniciar sesión');
        this.loadingFunc(false);
      },
      complete: () => {
        this.loadingFunc(false);
      },
    })
  }

  loadingFunc(loading: boolean) {
    this.loading = loading;
    loading ? this.spinner.show() : this.spinner.hide();
  }
}
